import React from 'react';

import sAction from 'sAction';

function Error404() {
    return (
        <div className="error404">
            <div className="error404Container">
                <img src={sAction.param.companyLogo} className='error404ImgLogo' />
                <h1 className="error404Title">404</h1>
                <p className="error404Text">Page not found</p>
                <br />
                <a href='/' className="error404Button">Go to home page</a>
            </div>
        </div>
    );
}

export default Error404;
